export default __webpack_public_path__ + "static/media/whatsapp.6c88c1a4.svg";